function getENV() {
  // make sure the script not throwing error under nodejs.
  var win  = typeof window !== 'undefined'    ? window              : {};
  var href = typeof location !== 'undefined'  ? location.href       : '';
  var ua   = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  var is_stupid_ios = /ios|iphone|ipad|ipod/i.test(ua); // iOS下UA非常不可靠

  //优先加载自定义环境
  if (!!win._KNB_CUSTOM_ENV) {
    return {
      isWX: !!win._KNB_WX,
      isMTNB: !!win._KNB_MTNB,
      isTitans: !!win._KNB_TITANS,
      isHBNB: !!win._KNB_HBNB,
      isDPApp: !!win._KNB_DPAPP
    }
  }

  var regDP = win._KNB_REGDP || /dp\/com\.dianping\.[\w\.]+\/([\d\.]+)/i;
  var regMT = win._KNB_REGMT || /moviepro|MTNB|Meituan|MOMA/i;
  var regHB = win._KNB_REGHB || /iHotel|HBNB/i;
  var regWX = win._KNB_REGWX || /micromessenger/i;
  var regTitans = win._KNB_REGTITANS || /TitansX/i;

  var isWX     = regWX.test(ua);
  var isDPApp  = regDP.test(ua);
  var isMTNB   = regMT.test(ua) || /f=(iphone|ipad|ipod|android)/.test(href);
  var isHBNB   = regHB.test(ua) && !win._MTNB;
  var isTitans = function() {
    if (href.indexOf('knb_force_use_titans') > -1) return true;
    if (is_stupid_ios) return !!win._TitansX;
    return regTitans.test(ua);
  }();

  var isMiniProgramWebview = win.__wxjs_environment === 'miniprogram';

  var isNative = isDPApp || isHBNB || isTitans || regMT.test(ua) || isMiniProgramWebview;
  //TitansNoX和点评包名的优先级高于其他，修复点评下引入美团实现的bug
  if (/titansnox/i.test(ua) && isDPApp) {
    isTitans = isHBNB = isWX = isMTNB = false;
  } 
  // order matters
  if (isWX)     { isTitans = isHBNB = isDPApp = isMTNB = false; }
  if (isTitans) { isDPApp  = isWX   = isMTNB  = isHBNB = false; }
  if (isHBNB)   { isTitans = isWX   = isDPApp = isMTNB = false; }
  if (isMTNB)   { isTitans = isWX   = isDPApp = isHBNB = false; }
  if (isDPApp)  { isTitans = isWX   = isMTNB  = isHBNB = false; }

  return {
    isWX: isWX,
    isTitans: isTitans,
    isHBNB: isHBNB,
    isDPApp: isDPApp,
    isMTNB: isMTNB,
    isNative: isNative,
    isMiniProgramWebview: isMiniProgramWebview,
  };
}

module.exports = getENV();
module.exports.getENV = getENV;  // make it testable



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/env.js
// module id = 295
// module chunks = 1 12 14